export const specialCharRegex = new RegExp('[!@#$%^&*(),.?":{}|<>]');
export const numbersRegex = new RegExp("[0-9]");
export const capitalLetterRegex = new RegExp("[A-Z]+");
export const lowerCaseLetterRegex = new RegExp("[a-z]+");
